<template>
  <div class="airspaceManagement">
    <div id="svg-container"></div> <!-- 用于插入 SVG 的容器 -->
    <div class="openLeft" title="空域协同" v-show="!openLeft&&!isOpenOne" @click="openSynergy">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="openPlan" title="空域使用计划" v-show="!openPlan&&!isOpenOne" @click="handelOpenPlan">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="closeLeft" v-if="openLeft" @click="closeSynergy">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div class="closePlan" v-if="openPlan" @click="closePlanTime">
      <img src="../../assets/img/2dmap/pop_close_open.png" alt=""/>
    </div>
    <div v-show="!openLeft&&!isOpenOne" class="heightSliderWrap">
      <span class="spanClass">{{ this.value[0]+ "~"+ this.value[1] }}</span>
      <el-slider
        class="heightSlider "
        v-model="value"
        vertical
        range
        :min="0"
        :max="3000"
        :step="15"
        @change="handelHeightSlider"
        :marks="marks"
      >
      </el-slider>
    </div>
    <div class="leftContent" v-show="openLeft">
      <div class="itemTitle">
        <div class="itemTitleText">空域协同</div>
      </div>
      <div class="taskSearchBox">
        <el-input
          placeholder="请输入空域名称"
          v-model="searchKeyWord "
          @keyup.enter.native="searchClick"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchClick"></i>
        </el-input>
      </div>
      <div class="selectGroup">
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item class="alarmtime" label="空域类型" prop="name">
            <el-select v-model="airSpaceType" @change="changeType" placeholder="请选择空域类型">
              <el-option
                v-for="item in airSpaceTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="alarmtime" label="审批类型" prop="name">
            <el-select v-model="approvalType" @change="changeType" placeholder="请选择审批类型">
              <el-option
                v-for="item in approvalTypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="airSpaceListTitle">
        <div style="width: 130px">名称</div>
        <div style="width: 80px">类型</div>
        <div style="width: 120px">审批类型</div>
        <div style="width: 120px">审批单位</div>
        <div style="width: 150px">开始时间</div>
        <div style="width: 150px">结束时间</div>
        <div style="width: 50px">激活</div>
      </div>
      <div class="airSpaceList">
        <div v-for="item in airSpaceList" class="airSpaceItem">
          <span style="width: 130px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                :title="item.airspaceName">{{ item.airspaceName }}</span>
          <span style="width: 80px">{{ airSpaceTypeOption.filter(v => item.type === v.value)[0].label }}</span>
          <span
            style="width: 120px">{{ approvalTypeOption.filter(v => item.approvingType === v.value)[0].label }}</span>
          <span style="width: 120px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                :title="item.approvingUnit">{{ item.approvingUnit }}</span>
          <span style="width: 150px">{{ item.startTime.replace(/:\d{2}$/, '') }}</span>
          <span style="width: 150px">{{ item.endTime.replace(/:\d{2}$/, '') }}</span>
          <span style="width: 50px">
              <el-checkbox @change="handelActive(item.id,item.active)"
                           v-model="item.active === 1"></el-checkbox>
            </span>
        </div>
      </div>
    </div>
    <div class="leftPlan" v-show="openPlan">
      <div class="itemTitle">
        <div class="itemTitleText">空域使用计划</div>
      </div>
      <div id="chart" style="width: 100%;height:calc(100% - 82px);">
        <div class="timeSlider">
          <el-slider  v-model="sliderValue" :min="0" :max="86399" :step="1" @change="handleChange"
                     :format-tooltip="formatTooltip"></el-slider>
          <p>当前选择的时间: {{ currentTime }}</p>
        </div>
        <div class="timeListWrap">
          <div v-for="item in airSpacePlanData" >
            <timeAxis @update="handelOpenPlan"   :data="item"></timeAxis>
          </div>
        </div>


      </div>
    </div>
    <div
      ref="mapRef"
      id="airspace-container"
      style="width: 100%; height: 100%"
    ></div>

    <div class="changeAirSpace">
      <!-- 右侧 -->
      <div class="airSpaceBtn">
        <div
          class="chooseBtn"
          :class="showControl ? 'active' : ''"
          :title="showControl ? '隐藏管制空域' : '显示管制空域'"
          @click="
            showControl = !showControl;
            airSpace();
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${showControl ? 'guan_zhi_kong_yu_click' : 'guan_zhi_kong_yu'}.png`)
            "
            alt=""
          />
        </div>

        <div
          class="chooseBtn"
          :class="showMonitor ? 'active' : ''"
          :title="showMonitor ? '隐藏监视空域' : '显示监视空域'"
          @click="
            showMonitor = !showMonitor;
            airSpace();
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${showMonitor ? 'jian_shi_kong_yu_click' : 'jian_shi_kong_yu'}.png`)
            "
            alt=""
          />
        </div>
        <div
          class="chooseBtn"
          :class="showReport ? 'active' : ''"
          :title="showReport ? '隐藏报告空域' : '显示报告空域'"
          @click="
            showReport = !showReport;
            airSpace();
          "
        >
          <img
            :src="
              require(`../../assets/img/2dmap/${showReport ? 'bao_gao_kong_yu_click' : 'bao_gao_kong_yu'}.png`)
            "
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="levelOneBtns" >
      <div
        title="返回首页"
        class="backHome"
        @click="handleBackHome"
      >
        <div class="img"></div>
      </div>
    </div>
    <div class="changeAirSpaceBottom">
      <div class="situationMapBtns">
        <div class="situationBtn" @click="clickRoad()">
          <img
            :src="
            require(`../../assets/img/2dmap/${clickroad ? 'luwangtu_click' : 'luwangtu'}.png`)
          "
            alt=""
          />
        </div>
        <div class="situationBtn" @click="clickStar()">
          <img
            :src="
            require(`../../assets/img/2dmap/${clickstar ? 'weixingtu_click' : 'weixingtu'}.png`)
          "
            alt=""
          />
        </div>
      </div>
    </div>
    <div id="chooseAirspace" v-show="flyArea">
      <div class="airspaceTitle"><span>空域详情</span></div>
      <div class="close" @click="close()">
        <img src="../../assets/img/2dmap/jiantou_xiashoulong.png" alt=""/>
      </div>
      <el-form
        :model="airSpaceInfo"
        ref="airSpaceInfo"
        label-width="120px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-col v-if="shapeType===1" class="positionSet">
          <el-form-item  label="中心点" prop="center">
            <el-input
              v-model="airSpaceInfo.center"
              type="text"
              disabled
              placeholder="请填写中心点经纬度以逗号隔开"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="shapeType===1" class="positionSet">
          <el-form-item label="半径" prop="radius">
            <el-input
              v-model="airSpaceInfo.radius"
              type="text"
              disabled
              placeholder="请填写半径"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-row class="coordinateRow" v-if="shapeType===0">
          <el-form-item class="coordinate"
                        v-for="(coordinate, index) in airSpaceInfo.airSpaseCoordinateArr"
                        :label="`坐标点 ${index+1}`"
                        :key="coordinate.key"
                        :prop="`airSpaseCoordinateArr.${index}.value`"
          >
            <el-input v-model="coordinate.value" disabled placeholder="经度，纬度以逗号分隔">
              <!--              <template slot="suffix">-->
              <!--                <el-button disabled :disabled="airSpaceInfo.airSpaseCoordinateArr.length===1"-->
              <!--                           @click.prevent="removeCoordinateByedit(coordinate)">删除-->
              <!--                </el-button>-->
              <!--                <el-button disabled :disabled="airSpaceInfo.airSpaseCoordinateArr.length>16" @click="addCoordinateByedit">新增</el-button>-->
              <!--              </template>-->
            </el-input>
          </el-form-item>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="select" label="空域类型" prop="type">
              <el-select v-model="airSpaceInfo.type" placeholder="请选择空域类型">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="alarmtime" label="空域名称" prop="name">
              <el-input
                disabled
                v-model="airSpaceInfo.name"
                type="text"
                placeholder="请填写空域名称"
              >
              </el-input>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="alarmtime" label=" 底面高度" prop="bottomHeight">
              <el-input
                disabled
                v-model="airSpaceInfo.bottomHeight"
                type="text"
                placeholder="请填写底面高度"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="空域高度" prop="height">
              <el-input
                disabled
                v-model="airSpaceInfo.height"
                type="text"
                placeholder="请填写空域高度"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="time" label="开始时间" prop="date1">
              <el-date-picker
                disabled
                v-model="airSpaceInfo.date1"
                type="datetime"
                placeholder="请选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="time" label="结束时间" prop="date2">
              <el-date-picker
                disabled
                v-model="airSpaceInfo.date2"
                type="datetime"
                placeholder="请选择时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              class="alarmtime"
              label="告警时间(分钟)"
              prop="minute"
            >
              <el-input
                disabled
                v-model="airSpaceInfo.minute"
                type="text"
                placeholder="请填写时间"
              >
                <!-- <template slot="append">分钟</template> -->
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="面积(km²)" prop="area">
              <el-input v-model="airSpaceInfo.area" disabled type="text" >
                <!-- <template slot="append">km²</template> -->
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="select" label="审批类型" prop="approvingType">
              <el-select v-model="airSpaceInfo.approvingType" disabled placeholder="请选择审批类型">
                <el-option
                  v-for="item in approvingTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="alarmtime" label="审批单位" prop="approvingUnit">
              <el-input
                v-model="airSpaceInfo.approvingUnit"
                type="text"
                placeholder="请填写审批单位"
                disabled
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item class="alarmtime" label="申请单位" prop="institution">
              <el-input
                disabled
                v-model="airSpaceInfo.institution"
                type="text"
                placeholder="请填写申请单位"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="note" label="备注" prop="note">
              <el-input
                disabled
                v-model="airSpaceInfo.note"
                :rows="1"
                type="textarea"
                placeholder="无"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                class="select"
                label="省份"
                :rules="[
                  { required: true, trigger: 'change', message: '请选择省份' },
                ]"
              >
                <el-select
                  @change="handleProvinceChange(selectedProvince)"
                  v-model="selectedProvince"
                  placeholder="请选择省份"
                >
                  <el-option
                    v-for="province in provinces"
                    :key="province.code"
                    :label="province.name"
                    :value="province.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="alarmtime"
                label="城市"
                :rules="[
                  { required: false, trigger: 'change', message: '请选择城市' },
                ]"
              >
                <el-select
                  @change="handleCityChange(selectedCity)"
                  v-model="selectedCity"
                  placeholder="请选择城市"
                  :disabled="!selectedProvince"
                >
                  <el-option
                    v-for="city in cities"
                    :key="city.code"
                    :label="city.name"
                    :value="city.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                class="note"
                label="区/县"
                :rules="[
                  { required:false, trigger: 'change', message: '请选择区域' },
                ]"
              >
                <el-select
                  v-model="selectedDistrict"
                  placeholder="请选择区/县"
                  :disabled="!selectedCity"
                >
                  <el-option
                    v-for="district in districts"
                    :key="district.code"
                    :label="district.name"
                    :value="district.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </div>

  </div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-draw";
import "leaflet-geometryutil";
import "leaflet-draw/dist/leaflet.draw.css";
import echarts from "echarts";
import timeAxis from "./time-axis/timeAxis.vue";
import {
  wgs84ToGcj02,
  gcj02ToWgs84
} from "../../assets/js/map/ConverseLngAndLa";
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/leaflet.markercluster.js';
import {timestampToTime} from "../../utils/tools";

export default {
  components:{
    timeAxis
  },
  name: "airspaceManagement",
  data() {
    let marks = {}
    const step = 15;
    for (let i = 0; i <= 3000; i += step) {
      if (i === 0 || (i % 150 === 0 && i<901)||(i % 300 === 0 && i>900)) {
        marks[i] = `--- ${i}`;
      } else {
        marks[i] = '-';
      }
    }
    return {
      provinces: [],
          cities:[],
          districts:[],
          selectedProvince: '',
          selectedCity: '',
          selectedDistrict: '',
      value: [0, 3000],
      marks: marks,
      timeAirspaceIds:[],
      airSpacePlanData:[],
      openPlan: false,
      airSpaceList: [],
      approvingTypeOptions:[
        {
          value: 1,
          label: "军方"
        },
        {
          value: 2,
          label: "政府"
        },
      ],
      approvalTypeOption: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "军方"
        },
        {
          value: 2,
          label: "政府"
        },
      ],
      airSpaceTypeOption: [
        {
          value: 5,
          label: "全部"
        },
        {
          value: 0,
          label: "禁飞区"
        },
        {
          value: 1,
          label: "电子围栏"
        },
        {
          value: 3,
          label: "适飞区"
        },
        {
          value: 4,
          label: "受限区"
        }
      ],
      airSpaceType: 5,
      approvalType: 0,
      searchKeyWord: '',
      openLeft: false,//左侧开关
      openRight: true,//右侧开关
      map: null,
      // mapcenter: [24.9402, 118.1806],//南安
      // mapcenter: [25.20249487751626, 118.44143629074098],//南安九都镇
      mapcenter: [31.2995549, 121.4511],//上海市静安
      // mapcenter: [32.06, 118.8],//南京
      open: false,
      isButtonActive: true, // 控制按钮是否可点击
      activeLayer: 0, //目前的图层
      clickstar: true,
      clickroad: false,
      drawControl: null, //空域选择类型控件
      drawnItems: null,
      ploygonChecked: false, //选择多边形
      circleChecked: false, //选择圆形
      showControl: true, //选择管制空域
      electronicFenceChecked: true, //选择电子围栏
      showMonitor: true, //选择监视空域
      showReport: true, //选择报告空域
      noflyAirSpaces: [], //禁飞空域
      canflyAirSpaces: [], //适飞空域
      limitAirSpaces: [], //受限空域
      latlngs: [], //选择空域多边形的点
      shapeType: 0,//0多边形，1圆
      //所有数据
      airSpaces: [], //所有空域
      //圆
      center: null,
      radius: 0,
      options: [
        {
          value: 0,
          label: "禁飞区"
        },
        {
          value: 1,
          label: "电子围栏"
        },
        {
          value: 3,
          label: "适飞区"
        },
        {
          value: 4,
          label: "受限区"
        },
        {
          value: 11,
          label: "管制空域"
        },
        {
          value: 21,
          label: "监视空域"
        }
      ],
      originLayer:
        "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
      roadUrlTemplate:
        "https://wprd01.is.autonavi.com/appmaptile?langzh_cn&size=1&scale=1&style=8{ltype}&x={x}&y={y}&z={z}",
      satelliteUrlTemplate:
        "https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}",
      flyArea: false,
      planLines: [], //所有计划航线
      positionLines: null, //定位的航线
      positRoadWhite: null, //定位航线的白底
      planlineWhite: [], //航线白底
      runRoadWhites: [], //航线白底
      airLinePositions: [], //所有当前定位航线的航点
      airLinePorts: [], //所有计划航线的（航点）
      airPorts: [], //所有航点（包含起降点）
      addAirSpaseType: 1, //新建空域类型 1手绘 2.自动生成
      autoAirSpase: null,
      airSpaseArrChange: false, //空域数组是否改变
      myChart: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      airSpaceInfo: {
        region: "适飞区",
        height: "200m",
        institution: "hjjj",
        name: "1号飞行区",
        date1: "2024-12-19 00:00:00",
        date2: "2024-12-24 00:00:00",
        minute: '56',
        area: "200㎡",
        note: "sdhudh",
        airspacePointArry: '',
        airSpaseCoordinateArr: [{value: ''}],
        center: '',
        radius: '',
        id: null,
      },
      sliderValue: 0,
      currentTime: '00:00:00'
    };
  },
  computed: {
    isOpenOne() {
      return this.openPlan || this.openLeft
    },
    uBtnPermissionList() {
      return this.getPageBtnRole('areaspaceManagement') || []
    },
    airSpaceShowIds(){
      if(this.airSpaceList.length){
        return this.airSpaceList.map(v=>(v.id))
      }else {
        return []
      }
    }
  },
  watch: {},
  mounted() {
    this.getAllProvince()
    this.currentTime = this.formatTime(this.sliderValue);
    this.getAirSpaceData().then(()=>{
      this.airSpace()
    })
    window.timer1 = setInterval(() => {
    }, 60000)
    this.initMap();
    //设备
    window.addEventListener('resize', this.handleResize, {passive: true});
  },
  beforeDestroy() {
    if (window.timer1) {
      clearInterval(window.statisicsTimer);
      window.timer1 = null;
    }

  },
  methods: {
    getAllProvince(){
      this.getRequest("/uav-task-server/region/getAllProvince").then(res => {
                    let oData = res.data;
                    if (oData.code == 0) {
                  this.provinces = oData.data

                    }
                  })

    },
    handleProvinceChange(provinceCode) {
          // 清空市和区绑定的值
          this.selectedDistrict = '';
          this.selectedCity = '';
        this.getCitiesByProvince(provinceCode)
        },
    handleDistrictChange(selectedProvince){
      this.getRequest(`/uav-task-server/airspace/queryAirspace?all=all&bottomHeight=0&topHeight=810&regionCode=${selectedProvince}`).then(res => {
                      let oData = res.data;
                      if (oData.code == 0) {

                      }
                    })
    },
    handleCityChange(cityCode) {
      // 清空区绑定的值
      this.selectedDistrict = '';
     this.getDistrictsByCity(cityCode)
    },
    getCitiesByProvince(provinceCode) {
      this.getRequest(`/uav-task-server/region/getCity?provinceCode=${provinceCode}`).then(res => {
                      let oData = res.data;
                      if (oData.code == 0) {
                      this.cities = oData.data
                      }
                    })
    },
    getDistrictsByCity(cityCode) {
      this.getRequest(`/uav-task-server/region/getDistrict?cityCode=${cityCode}`).then(res => {
              let oData = res.data;
              if (oData.code == 0) {
              this.districts = oData.data
              }
            })
    },
    handelHeightSlider(v){
      this.airSpace()

    },
    changeType(){
      this.getAirSpaceData().then(()=>{
        this.airSpace()
      })
    },
    closeSynergy(){
      this.airSpaceType = 5
      this.approvalType = 0
      this.searchKeyWord = ''
      this.openLeft = false
      this.airSpace()
    },
    openSynergy(){
      this.getAirSpaceData().then(()=>{
        this.openLeft = true
      })
    },
    closePlanTime(){
      this.openPlan = false;
      this.timeAirspaceIds = []
      this.sliderValue = 0
      this.currentTime = '00:00:00'
      this.airSpace()
    },
    // 格式化时间的函数
    formatTime(seconds) {
      const hours = Math.floor(seconds / 3600).toString().padStart(2, '0');
      const minutes = Math.floor((seconds % 3600) / 60).toString().padStart(2, '0');
      const secs = (seconds % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}:${secs}`;
    },
    // 格式化滑块 tooltip 的函数
    formatTooltip(value) {
      return this.formatTime(value);
    },
    // 滑块值改变时的处理函数
    handleChange(value) {
      this.currentTime = this.formatTime(value);
      let date = timestampToTime(new Date()).split(' ')[0] + ' '+this.currentTime
      this.getRequest("/uav-task-server/airspace/getAirspaceByTimeFOrGraph?time="+date).then(res => {
          const data = res.data
          if (data.code === 0) {
            this.timeAirspaceIds = data.data
            this.airSpace()
          }else {
            this.$message.error({
              message: data.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
      })

    },

    close() {
      this.flyArea=false
    },
    handelOpenPlan(type){
      this.getRequest("/uav-task-server/airspace/getAirspaceUseGraph").then(res => {
        const data = res.data
        if (data.code === 0) {
          this.airSpacePlanData = data.data.data
          if(type !== 'update'){
            this.openPlan = true;
          }
        }else {
          this.$message.error({
            message: data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    handelActive(id, active) {
      this.airSpaceList.forEach(v => {
        if (v.id === id) {
          v.active = !active
        }
      })
      let status = active ? 0 : 1
      this.postJsonRequest("/uav-task-server/airspace/changeAirspaceActive", {id: id, active: status}).then(res => {
        const data = res.data
        if (data.code === 0) {
          this.getAirSpaceData().then(()=>{
            this.airSpace()
          })
          this.$message({
            message: data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
        } else {
          this.$message.error({
            message: data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      })
    },
    searchClick() {
      this.getAirSpaceData().then(()=>{
        this.airSpace()
      })
    },
    getAirSpaceData() {
      let data = {}
      if (this.airSpaceType === 5) {
        data.type = [0, 1, 3, 4]
      } else {
        data.type = [this.airSpaceType]
      }
      if (this.approvalType === 0) {
        data.approvingType = [1, 2]
      } else {
        data.approvingType = [this.approvalType]
      }
      this.searchKeyWord ? data.airspaceName = this.searchKeyWord : ''
     return this.postJsonRequest("/uav-task-server/airspace/queryAirspaceByConditions", data).then(res => {
        const data = res.data
        if (data.code === 0) {
          this.airSpaceList = data.data
          return data.data
        } else {
          this.$message.error({
            message: data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }

      })
    },
    initMap() {
      // 初始化地图
      var layer = L.tileLayer(
        // "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
        this.satelliteUrlTemplate
      );
      //创建地图
      let map = L.map("airspace-container", {
        center: this.mapcenter, //中心坐标
        zoom: 15, //缩放级别
        minZoom: 3,
        maxZoom: 18,
        zoomControl: true, //缩放组件
        attributionControl: false, //去掉右下角logol
        layers: [layer] //图层
      });
      // map.setView([24.9402, 118.1806], 10)
      this.map = map;

      // 初始化Leaflet.draw控件
      var drawnItems = new L.FeatureGroup();
      this.map.addLayer(drawnItems);
      // 初始化绘制控件
      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: drawnItems
        }
      });
      // 将绘制控件添加到地图上
      this.map.addControl(this.drawControl);
      // this.getUserLocation();
      // 监听绘制事件
      let that = this;
      map.on("draw:created", function (event) {
        // 将绘制的图层添加到地图上
        var layer = event.layer;
        drawnItems.addLayer(layer);
        that.drawnItems = drawnItems;
        //获取多边形数据
        if (that.ploygonChecked) {
          //获取面积，结果单位是平方米
          let area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
          // 将面积转换为平方千米
          let areaInKm = area / 1000000;
          that.ruleForm.area = areaInKm.toFixed(2);
          // 获取图层的所有顶点
          var latlngs = layer.getLatLngs();
          let pointArr = [];
          latlngs[0].forEach(point => {
            let point1 = gcj02ToWgs84(point.lng, point.lat);
            pointArr.push(point1);
          });
          that.latlngs = pointArr;
        }
      });
      //监听鼠标开始绘制事件
      map.on("mousedown", function (e) {
        if (that.circleChecked && that.addAirSpaseType === 1) {
          // 获取鼠标点击的经纬度作为圆心
          that.center = e.latlng;
        }
      });
      //监听鼠标结束绘制事件
      map.on("mouseup", function (e) {
        if (that.circleChecked && that.addAirSpaseType === 1) {
          // 计算圆形半径
          var radius = that.center.distanceTo(e.latlng);
          that.radius = radius;
          // 计算面积
          if (radius > 0) {
            let area = Math.PI * Math.pow(radius, 2);
            let areaInKm = area / 1000000;
            that.ruleForm.area = areaInKm.toFixed(2);
          }
        }
      });
      map.on("click", function (e) {

      });

      // 地图加载完成后再执行操作
      map.whenReady(() => {
        //监听地图缩放
        map.on("zoomend", function () {
          // 获取当前缩放级别
        });
        //定位用户地理位置
        // this.getUserLocation();
      });
    },
    //绘制空域
    airSpace() {
      //三大类是否选择作为参数
      let strArr = []
      if (this.showReport) {
        strArr.push('cateType=10')
      }
      if (this.showMonitor) {
        strArr.push('cateType=30')
      }
      if (this.showControl) {
        strArr.push('cateType=20')
      }
      if(!this.showReport&&!this.showMonitor&&!this.showMonitor){
        strArr.push('cateType=40')
      }
      const cateTypeStraight = strArr.join('&')
      this.getRequest(`/uav-task-server/airspace/queryAirspace?all=all&bottomHeight=${this.value[0]}&topHeight=${this.value[1]}&${cateTypeStraight}`)
        .then(res => {
          let _this = this
          let oData = res.data;
          if (oData.code == 0) {
            // //绘制前清除空域
            if (this.airSpaces.length > 0) {
              this.airSpaces.forEach(item => {
                this.map.removeLayer(item);
              });
            }
            let res = JSON.parse(oData.data);
            let features = res.features
            //筛选右侧显示的报告空域
            // if(this.airSpaceShowIds.length){
            //   features = res.features.filter(v=>
            //     this.airSpaceShowIds.includes(v.properties.id)
            //   )
            // }
            if(this.openLeft){
              features = features.map(v => {
                if(v.properties.TYPE>= 0&&v.properties.TYPE <=9){
                  if(this.airSpaceShowIds.includes(v.properties.id)){
                    return  v
                  }
                  return null
                }else {
                  return v
                }
              }).filter(item => item!== null);
            }
              if(this.openPlan){
                features = features.filter(v => this.timeAirspaceIds.includes(v.properties.id));
              }
            // let features = res.features
            //设置颜色分类
            if (features.length > 0) {
              //0 禁飞区（红色） 1 电子围栏（有个属性控制，在电子围栏内是否可飞，红色） 2. 3.适飞区(绿色) 4. 限飞区(黄色)  0-9 报告空域(大类)
              //11-19   11-管制空域(大类) //橙色
              //21-29   21-监视空域(大类) //黄色
              const colorType = ["red", "red", "", "green", "yellow"];
              //遍历每一类的空域
              features.forEach(space => {
                const active = space.properties.ACTIVE
                let shapeType = space.properties.SHAPETYPE;
                //遍历该类型下的所有空域多边形
                space.geometry.coordinates.forEach(coordinate => {
                  //转换经纬度为纬经度
                  let changedCoord = [];
                  coordinate[0].forEach(point => {
                    let wgsPoint = wgs84ToGcj02(point[0], point[1]);
                    changedCoord.push([wgsPoint[1], wgsPoint[0]]);
                  });
                  let svgGradient1 = `
                       <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                  <defs>
                      <radialGradient id="redSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ff5555; stop-opacity:0" />
                            <stop offset="100%" style="stop-color:#ff5555;stop-opacity:1" />
                      </radialGradient>
                  </defs>
                       </svg>`;
                  let svgGradient2 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="greenSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                             <stop offset="80%" style="stop-color:#0fd077; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#0fd077;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                  let svgGradient3 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="yellowSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           <stop offset="80%" style="stop-color:#ffc877; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:#ffc877;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                  let svgGradient4 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="graySpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:gray; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:gray;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;
                  let svgGradient5 = `
                         <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" >
                    <defs>
                        <radialGradient id="orangeSpace" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
                           stop offset="80%" style="stop-color:orange; stop-opacity:0" />
                               <stop offset="100%" style="stop-color:orange;stop-opacity:1" />
                        </radialGradient>
                    </defs>
                         </svg>`;

                  // 将 SVG 渐变添加到文档
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient1);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient2);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient3);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient4);
                  document.getElementById('svg-container').insertAdjacentHTML('afterbegin', svgGradient5);
                  let polygon = null;
                  if (shapeType == 0) { //0多边形，1圆形
                    //绘制多边形
                    polygon = L.polygon(changedCoord, {
                      color: "rgba(0,0,0,0.5)", //边框颜色#aa0000
                      fillColor: space.properties. ACTIVE?space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? 'red'
                        : space.properties.TYPE === 3
                          ? 'green'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'yellow'
                            : space.properties.TYPE === 11
                              ? 'orange'
                              : null:null, //填充颜色
                      fillOpacity: 0.3, //填充透明度
                      weight: active ? 1 : 2 //边框宽度
                    }).addTo(this.map);
                    //双击修改空域
                    polygon.on('dblclick', (e) => {
                      this.open = false
                      if(space.properties.remark&&space.properties.remark.includes('机场')||!this.uBtnPermissionList.includes('airspace-add')){
                        return
                      }
                      this.airSpaceInfo ={
                        type: "",
                        height: "",
                        institution: "",
                        name: "",
                        date1: "",
                        date2: "",
                        minute: '',
                        area: "",
                        note: "",
                        airspacePointArry: '',
                        airSpaseCoordinateArr: [{value: ''}],
                        center: '',
                        radius: '',
                        id: null,
                        objectId: null,
                        approvingUnit: "",
                        approvingType: "",
                      }
                      this.shapeType = 0
                      this.airSpaceInfo.type = space.properties.TYPE
                      this.airSpaceInfo.airSpaseCoordinateArr = space.geometry.coordinates[0][0].map(v=>({value:v[0].toFixed(7)+','+v[1].toFixed(7)}))
                      this.airSpaceInfo.height = space.properties.HEIGHT
                      this.airSpaceInfo.date2 = new Date(space.properties.ENDTIME)
                      this.airSpaceInfo.minute = space.properties.ALARMTIME
                      this.airSpaceInfo.date1 = new Date(space.properties.STARTTIME)
                      this.airSpaceInfo.name = space.properties.airspaceName
                      this.airSpaceInfo.institution = space.properties.applicant
                      this.airSpaceInfo.area = space.properties.area
                      this.airSpaceInfo.note = space.properties.remark
                      this.airSpaceInfo.radius = space.properties.RADIUS
                      this.airSpaceInfo.id = space.properties.id
                      this.airSpaceInfo.objectId = space.properties.OBJECTID
                      this.airSpaceInfo.bottomHeight = space.properties.BOTTOM_HEIHGT
                      this.airSpaceInfo.approvingUnit = space.properties.APPROVING_UNIT
                      this.airSpaceInfo.approvingType = space.properties.APPROVING_TYPE
                      this.flyArea = true;
                    });
                  } else {
                    polygon = L.circle(changedCoord[0], {
                      radius: space.properties.RADIUS, // 设置圆的半径
                      color: "rgba(0,0,0,0.5)", // 设置圆的边框颜色
                      fillColor:  space.properties. ACTIVE?space.properties.TYPE === 0 || space.properties.TYPE === 1
                        ? 'url(#redSpace)'
                        : space.properties.TYPE === 3
                          ? 'url(#greenSpace)'
                          : space.properties.TYPE === 4 || space.properties.TYPE === 21
                            ? 'url(#yellowSpace)'
                            : space.properties.TYPE === 11
                              ? 'url(#orangeSpace)'
                              : null:null, //填充颜色
                      fillOpacity: 0.5, // 设置圆的填充透明度
                      weight: active ? 1 : 2 //边框宽度
                    }).addTo(this.map);
                    polygon.on('dblclick', (e) => {
                      this.open = false
                      if(!this.uBtnPermissionList.includes('airspace-add')){
                        return
                      }
                      this.airSpaceInfo ={
                        type: "",
                        height: "",
                        bottomHeight: "",
                        institution: "",
                        name: "",
                        date1: "",
                        date2: "",
                        minute: '',
                        area: "",
                        note: "",
                        airspacePointArry: '',
                        airSpaseCoordinateArr: [{value: ''}],
                        center: '',
                        radius: '',
                        id: null,
                        objectId: null,
                        approvingUnit: "",
                        approvingType: "",
                      }
                      this.shapeType = 1
                      this.airSpaceInfo.type = space.properties.TYPE
                      this.airSpaceInfo.height = space.properties.HEIGHT
                      this.airSpaceInfo.center = space.geometry.coordinates[0][0][0].map(str=>str.toFixed(7)).join(',')
                      this.airSpaceInfo.date2 = new Date(space.properties.ENDTIME)
                      this.airSpaceInfo.minute = space.properties.ALARMTIME
                      this.airSpaceInfo.date1 = new Date(space.properties.STARTTIME)
                      this.airSpaceInfo.name = space.properties.airspaceName
                      this.airSpaceInfo.institution = space.properties.applicant
                      this.airSpaceInfo.area = space.properties.area
                      this.airSpaceInfo.note = space.properties.remark
                      this.airSpaceInfo.radius = space.properties.RADIUS
                      this.airSpaceInfo.id = space.properties.id
                      this.airSpaceInfo.objectId = space.properties.OBJECTID
                      this.airSpaceInfo.bottomHeight = space.properties.BOTTOM_HEIHGT
                      this.airSpaceInfo.approvingUnit = space.properties.APPROVING_UNIT
                      this.airSpaceInfo.approvingType = space.properties.APPROVING_TYPE
                      this.$nextTick(()=>{
                        this.flyArea = true;
                      })

                    });
                  }
                  let _this = this
                  // 添加 hover 事件监听器 移入移出
                  if (polygon) {
                    let popup;

                    function togglePopup(latlng, showPopup, map) {
                      if (showPopup) {
                        popup = L.popup({
                          closeButton: false // 设置closeButton为false来隐藏关闭按钮
                        })
                          .setLatLng(latlng)
                          .setContent(`
                            <div style="color:#000;font-weight:bold;text-align: center;font-size: 14px">${space.properties.airspaceName}(${space.properties.BOTTOM_HEIHGT}~${space.properties.HEIGHT+space.properties.BOTTOM_HEIHGT}m)</div>
                           <div>${space.properties.STARTTIME} ~ ${space.properties.ENDTIME} </div>
                          `)
                          .openOn(map);
                      } else {
                        popup.close()

                      }
                    }

                    polygon.on('mouseover', function (e) {
                      //这里this指向map
                      togglePopup(e.latlng, true, _this.map);
                    });
                    polygon.on('mouseout', function (e) {
                      togglePopup(e.latlng, false, _this.map, e);
                    });
                  }
                  this.airSpaces.push(polygon)
                  // if (space.properties.TYPE === 0) {//禁飞
                  //   this.noflyAirSpaces.push(polygon)
                  // } else if (space.properties.TYPE === 3) {//适飞
                  //   this.canflyAirSpaces.push(polygon)
                  // } else if (space.properties.TYPE === 4) {//限飞
                  //   this.limitAirSpaces.push(polygon)
                  // }else if (space.properties.TYPE === 4) {//限飞
                  //   this.limitAirSpaces.push(polygon)
                  // }
                });
              });
            }
            //将航线 移动到最顶层
            if (this.planlineWhite.length > 0) {
              this.planlineWhite.forEach(planline => {
                planline.removeFrom(this.map);
                planline.addTo(this.map);
              });
            }
            if (this.planLines.length > 0) {
              this.planLines.forEach(planline => {
                planline.removeFrom(this.map);
                planline.addTo(this.map);
              });
            }
          } else {
          }
        });
    },
    clickRoad() {
      this.clickroad = !this.clickroad;
      if (this.clickroad) {
        this.clickstar = false;
        this.switchLayer("road");
      } else {
        this.switchLayer("back");
      }
    },
    clickStar() {
      this.clickstar = !this.clickstar;
      if (this.clickstar) {
        this.clickroad = false;
        this.switchLayer("satellite");
      } else {
        this.switchLayer("back");
      }
    },
    switchLayer(layerType) {
      window.postMessage("changeLayerType", "*");
      // this.againPlaneWay();
      switch (layerType) {
        case "road":
          this.activeLayer = 1;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.roadUrlTemplate, {
            ltype: "11",
            attribution: "高德地图路网"
          }).addTo(this.map);
          break;
        case "satellite":
          this.activeLayer = 2;
          // 移除现有图层并添加卫星影像图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.satelliteUrlTemplate, {
            attribution: "高德地图卫星影像"
          }).addTo(this.map);
          break;
        case "hot":
          this.activeLayer = 3;
          // 定义热力点数量，加热力半径
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var heatPoints = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            heatPoints[i] = [
              Math.random() * 0.28 + 39.78,
              Math.random() * 0.5 + 116.12,
              Math.random() * 80
            ];
          }
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 调用渲染方法，传入半径，透明度参数，添加到地图
          this.heatLayer = L.heatLayer(heatPoints, {
            radius: heatRadius,
            minOpacity: 0.5
          }).addTo(this.map);

          break;
        case "wind":
          this.activeLayer = 3;
          var heatNumbers = 150,
            heatRadius = 30;
          // 加热力坐标信息数组
          var windData = [];
          // 遍历添加坐标信息
          for (var i = 0; i < heatNumbers; i++) {
            windData[i] = {
              lat: Math.random() * 0.28 + 39.78,
              lng: Math.random() * 0.5 + 116.12,
              angle: 45
            };
          }

          // 调用渲染方法，传入半径，透明度参数，添加到地图
          if (this.heatLayer) {
            this.map.removeLayer(this.heatLayer);
          }
          if (this.velocityLayer) {
            this.map.removeLayer(this.velocityLayer);
          }
          // 循环风向数据，绘制风向箭头
          var layer = windLayer(data);
          layer.addTo(this.map);

          break;
        // ... 同理添加其他图层
        case "back":
          this.activeLayer = 4;
          // 移除现有图层并添加路网图层
          this.map.eachLayer(layer => {
            if (layer instanceof L.TileLayer) {
              this.map.removeLayer(layer);
            }
          });
          L.tileLayer(this.originLayer, {
            attribution: "高德原影像"
          }).addTo(this.map);
          break;
      }
    },
    // 回到主页
    handleBackHome() {
      this.handledataCommand("taskControl");
    },
    // 数据下拉点击
    handledataCommand(command) {
      // console.log('handledataCommand--->', command)
      this.selectMenuIndex = command;
      this.$emit("backTwoMap", command);
      // 存储selectMenuIndex 到 webStorage中，用于刷新时返回到本页面
      sessionStorage.setItem("selectMenuIndex", command);
    },
    handleResize() {
      this.myChart && this.myChart.resize();
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

#chooseAirspace {
  position: absolute;
  bottom: 8px;
  //left: 800px;
  right: 50px;
  min-width: 240px;
  width: 48%;
  //height: 20%;
  z-index: 1004;
  background: rgba(1,9,17,0.68);
  padding: 10px 30px 10px 10px;
  //background-image: url("../../assets/img/2dmap/bac3.png");
  background-size: 100% 100%;
  opacity: 0.9;
}

.airspaceManagement {
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  //position: relative;
}


.taskControl >>> .planeMarker {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3000 !important;
}

.openAir {
  cursor: pointer;
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 26px;
  z-index: 1000;
  background: rgba(15, 86, 115, 0.4);
}

.openAir img {
  width: 100%;
  height: 100%;
}

.openLeft {
  cursor: pointer;
  position: absolute;
  //bottom: 8px;
  top: 104px;
  left: 8px;
  width: 48px;
  height: 48px;
  z-index: 1000;
}

.openPlan {
  cursor: pointer;
  position: absolute;
  //bottom: 8px;
  top: 154px;
  left: 8px;
  width: 38px;
  height: 38px;
  z-index: 1000;
}


.openLeft,
.openPlan img {
  width: 48px;
  height: 48px;
}

.leftContent {
  background: rgba(1,9,17,0.68);
  overflow: auto;
  display: flex;
  display: -webkit-flex;
  height: calc(100% - 92px);
  padding: 10px;
  flex-direction: column;
  width: 800px;
  z-index: 1000;
  position: absolute;
  top: 85px;
  left: 14px;
}
.leftPlan {
  background: rgba(1,9,17,0.68);
  overflow: auto;
  display: flex;
  display: -webkit-flex;
  height: calc(100% - 92px);
  padding: 10px;
  flex-direction: column;
  width: 900px;
  z-index: 1000;
  position: absolute;
  top: 85px;
  left: 14px;
}
.leftPlan .itemTitle {
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_header_long.png");
  background-size: 100%;
  padding-left: 44px;
  width: 100%;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  margin: 12px 0 12px 0;
}

.leftContent .itemTitle {
  height: 50px;
  background-image: url("../../assets/img/2dmap/pop_header_long.png");
  background-size: 100%;
  padding-left: 44px;
  width: 100%;
  font-size: 28px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  text-shadow: 1.84px 1.84px 1.84px 1.84px rgba(35, 21, 0, 0.48);
  margin: 12px 0 12px 0;
}

.taskSearchBox {
  height: 38px;
  margin-bottom: 12px;
}

.taskSearchBox >>> input {
  height: 38px;
  box-sizing: border-box;
  width: calc(100% - 5px);
  background: rgba(1,9,17,0.68);
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}

.taskSearchBox /deep/ .el-input__icon {
  font-size: 20px; /* 设置图标大小为 20px */
  width: 20px; /* 设置图标宽度为 20px */
  height: 20px; /* 设置图标高度为 20px */
  line-height: 38px;
  cursor: pointer;

}

>>> .taskSearchBox .el-input__suffix {
  right: 20px;
}

.taskSearchBox input >>> i {
  //border: 1px solid red;
  position: absolute;
  top: 7px;
  bottom: 7px;
  right: 32px;
}

.selectGroup {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.selectGroup .el-form {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.leftContent .airSpaceList {
  width: 100%;
  height: calc(100% - 136px);
  overflow: auto;
}

.airSpaceListTitle {
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  padding: 0 5px;
  color: #fff;
  height: 40px;
  font-size: 16px;
  line-height: 40px;
  background: rgba(0,174,255,0.5);
}

.airSpaceItem {
  width: 100%;
  height: 38px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  margin-bottom: 5px;
  background: rgba(1,9,17,0.68);
}
.airSpaceItem:hover {
  background: rgba(0, 174, 255, 0.5);
}

#svg-container {
  position: absolute; /* 绝对定位 */
  width: 0; /* 不占用空间 */
  height: 0;
  overflow: hidden; /* 隐藏溢出的内容 */
}

.closeLeft {
  z-index: 1003;
  cursor: pointer;
  position: absolute;
  left: 820px;
  top: 88px;
  width: 38px;
  height: 38px;
  background: rgba(15, 86, 115, 0.4);
}

.closePlan {
  z-index: 1003;
  cursor: pointer;
  position: absolute;
  left: 920px;
  top: 88px;
  width: 38px;
  height: 38px;
  background: rgba(15, 86, 115, 0.4);
}

.airSpaceBtn .chooseBtn {
  width: 48px;
  height: 48px;
  text-align: center;
  position: relative;
  margin-bottom: 20px;
}

.airSpaceBtn .chooseBtn img {
  width: 48px;
  height: 48px;
}

#chooseAirspace .title {
  width: 100%;
  height: 50px;
  background: url("../../assets/img/2dmap/kong_yu_guan_li.png") no-repeat;
  //background: url("../../assets/img/2dmap/pop_bg.png") no-repeat ;
}

.radio .checkbox {
  //position: absolute;
}

.radio .el-checkbox__label {
  font-family: Adobe Heiti Std;
  font-size: 16px;
  color: #ffffff;
}



.checkbox .is-checked .el-checkbox__label {
  color: #fff;
}

#chooseAirspace .el-form {
  margin-top: 25px;
}

#chooseAirspace .el-form .el-form-item {
  height: 45px;
  margin-bottom: 5px;
}

>>> .el-form .el-form-item__error {
  top: 33px;
  left: 1px;
}

>>> .el-form .el-form-item__label {
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #ffffff;
  line-height: 40px;
}

.select .el-select {
  width: 100% !important;
}

.select .el-select .el-input__inner {
  color: #fff;
  height: 30px;
  background: rgba(1,9,17,0.68) !important;
}

.select .el-select .el-input__suffix {
  right: 10px;
}

>>> .coordinateRow .el-input__suffix {
  right: 14px;
}

>>> .coordinateRow .el-input__inner {
  padding-right: 0px;
}

.select .el-select .el-input__suffix .el-input__icon {
  color: #fff;
  height: 30px;
  line-height: 30px;
}

.time .el-input__inner {
  color: #fff;
  height: 30px;
  line-height: 30px;
  background: rgba(1,9,17,0.68) !important;

}

.time .el-input__prefix {
  left: 5px !important;
}

.time .el-input__prefix .el-input__icon {
  line-height: 32px;
}

.time .el-date-editor {
  color: #fff !important;
  line-height: 30px !important;
}

.time .el-input {
  width: 100% !important;
}

.alarmtime .el-input {
  width: 100% !important;
}

.alarmtime .el-input .el-input__inner {
  color: #fff;
  height: 30px;
  line-height: 30px;
  background: rgba(1,9,17,0.68) !important;

}

.alarmtime .el-input .el-input-group__append {
  color: #fff;
  background: rgba(23, 11, 1, 0.50);

}

.alarmtime .el-form-item__content .el-input-group {
  vertical-align: middle;
}

.note .el-textarea {
  width: 100% !important;
}

.note .el-textarea .el-textarea__inner {
  color: #fff;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  line-height: 18px;
  background: rgba(23, 11, 1, 0.50);

}

.note .el-form-item__error {
  top: 47px !important;
}

.footer {
  height: 40px;
  margin-top: 20px;
}

.footer .el-form-item__content {
  margin-left: 0 !important;
}

.el-form .el-button {
  width: 80px;
  height: 40px;
  background: transparent;
  border: 0;
  background-size: 100% 100%;
}

.coordinateRow .el-button {
  width: 20px;
}

.footer .confirm {
  width: 68px;
  height: 32px;
  background-image: url("../../assets/img/2dmap/confirm.png");
}

.footer .cancel {
  margin-right: 68px;
  width: 68px;
  height: 32px;
  background-image: url("../../assets/img/2dmap/cancel.png");
}

.footer .delete {
  width: 68px;
  height: 32px;
  background-image: url("../../assets/img/2dmap/delete.png");
}

.footer .modify {
  margin-right: 68px;
  width: 104px;
  height: 32px;
  background-image: url("../../assets/img/2dmap/modify.png");
}


.el-form .el-button span {
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #dff2ff;
  line-height: 13px;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85);
}

.el-form .el-button span:hover {
  color: #fee075;
}

.preViewBtn {
  border: none;
  width: 88px;
  height: 42px;
  color: #ebebeb;
  font-size: 20px;
  background-image: url("../../assets/img/2dmap/btn_wrap.png");
}

>>> .leaflet-left {
  display: none;
}

.preViewBtn span {
  font-family: Source Han Sans CN;
  font-size: 18px;
  color: #dff2ff;
  line-height: 22px;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85);
}

.preViewBtn span:hover {
  color: #fee075;
}

/* 右侧 */
.airspaceManagement .backHome {
  width: 48px;
  height: 48px;
  position: absolute !important;
  bottom: 10px !important;
  z-index: 1000;
  cursor: pointer;
}

.leaflet-draw {
  display: none !important;
}

#airspace-container .leaflet-left {
  left: auto !important;
  top: auto !important;
  right: 28px !important;
  bottom: 115px !important;
}

#airspace-container .leaflet-left a {
  width: 38px;
  height: 38px;
  display: none;
}

#airspace-container .leaflet-left .leaflet-control-zoom-in {
  background-image: url("../../assets/img/2dmap/zoomout.png");
}

#airspace-container .leaflet-left .leaflet-control-zoom-in:hover {
  background-image: url("../../assets/img/2dmap/zoomout_click.png") !important;
}

#airspace-container .leaflet-left .leaflet-control-zoom-in span {
  display: none;
}

#airspace-container .leaflet-left .leaflet-control-zoom-out {
  background-image: url("../../assets/img/2dmap/zoomin.png");
}

#airspace-container .leaflet-left .leaflet-control-zoom-out:hover {
  background-image: url("../../assets/img/2dmap/zoomin_click.png");
}

#airspace-container .leaflet-left .leaflet-control-zoom-out span {
  display: none;
}

.leaflet-bar {
  border: none !important;
}

.leaflet-bar a {
  background-color: transparent !important;
}

.leaflet-control-zoom-in {
  margin-bottom: 6px;
}

.leaflet-control-zoom-in span {
  line-height: 45px;
  color: #bfd9ff;
}

.leaflet-control-zoom-out span {
  line-height: 45px;
  color: #bfd9ff;
}

.processStyle {
  width: 155px;
  height: 6px;
  margin-right: 10px;
  margin-left: 10px;
}

.rightBottomBottomText {
  width: 100px;
  height: 16px;
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}

.levelWrap {
  margin-top: 10px;
  width: 310px;
  flex-direction: column;
  height: 100%;
  display: flex;
  justify-content: space-between;
}


.el-select-dropdown {
  border: 0;
}

.el-scrollbar {
  //background: linear-gradient(-18deg, #1b5a99, #051f39) !important;
  box-shadow: 0px 3px 4px 1px rgba(0, 0, 0, 0.5) !important;
  opacity: 0.9;
  border-color: #00aeff !important;
}

.flyTop .flyText {
  font-size: 16px;
  font-family: Adobe Heiti Std, Adobe Heiti Std-R;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;
}


.openRight {
  cursor: pointer;
  position: absolute;
  /* //bottom: 8px; */
  top: 104px;
  right: 8px;
  width: 38px;
  height: 38px;
  z-index: 1000;
}

.openRight img {
  width: 38px;
  height: 38px;
}

.rightContent {
  display: flex;
  flex-direction: column; /* 子元素垂直排列 */
  flex: 1; /* 每列平分父元素宽度 */
  display: -webkit-flex;
  overflow: auto;
  height: calc(100% - 85px);
  z-index: 1000;
  position: absolute;
  top: 85px;
  right: 14px;
}

.closeRight {
  z-index: 1003;
  cursor: pointer;
  position: absolute;
  right: 368px;
  top: 100px;
  width: 38px;
  height: 38px;
  background: rgba(15, 86, 115, 0.4);
}

.rightContent .title {
  padding-left: 14px;
  background-repeat: no-repeat;
  background-size: cover;
  /* //width: 346px; */
  width: 100%;
  box-sizing: border-box;
  height: 50px;
  line-height: 50px;
  position: relative;
  margin-bottom: 2px;
  font-size: 26px;
  margin-top: 8px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: 400;
  font-style: italic;
  text-align: left;
  color: #ffffff;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16, 1, 0, 0.50);
  background-image: url("../../assets/img/2dmap/pop_bg.png")
}


</style>
<style scoped>
@font-face {
  font-family: 'PangMenZhengDao-3';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

@font-face {
  font-family: 'PangMenZhengDao-3-Regular';
  src: url(../../assets/font-awesome/fonts/PangMenZhengDao2.0.ttf);
}

* {
  box-sizing: border-box;
  user-select: none;
}

.fa-mouse-pointer {
  cursor: pointer;
}

>>> .el-input__placeholder {
  color: #999; /* 设置placeholder的字体颜色 */
}

>>> .weather-toolTip .weather {
  box-sizing: border-box;
  min-width: 295px;
  height: 212px;
  z-index: 1000;
  background-image: url("../../assets/img/2dmap/weather_bg.png");
  background-size: 100% 100%;
  padding: 26px;
  color: white;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

>>> .weather-toolTip .weather .params {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
  margin-bottom: 5px;
}

>>> .weather-toolTip .weather .nextImg {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
}

>>> .weather-toolTip .weather .weatherImg {
  position: absolute;
  top: 15px;
  right: 20px;
  width: 80px;
  height: 80px;
}

>>> .weather-toolTip .weather .address {
  font-size: 18px;
}

>>> .weather-toolTip .weather .top {
  margin-bottom: 10px;
}

>>> .weather-toolTip .weather .temperature {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
}

/*
>>> .leaflet-pane .leaflet-tooltip {
  background-color: transparent !important;
  border: none !important;
}
-*/
>>> .weather-toolTip {
  background-color: transparent !important;
  border: none !important;
}

>>> .el-input__inner {
  /* border: 1px solid #1D6DC8; */
  /* background-color: #153862; */
  border: unset !important;
  background: rgba(1,9,17,0.68) !important;
  border-radius: 6px;
  color: #fff;
  height: 32px;
}

>>> .el-radio__label {
  font-size: 20px !important;
}

>>> .el-radio__input.is-checked + .el-radio__label {
  color: #fff !important;
}

>>> .el-radio__label {
  color: #fff !important;
}

>>> .el-radio__input.is-checked .el-radio__inner {
  background: #fee075 !important;
  border-color: #c49100 !important;
}

#fenge {
  display: block;
  width: 70px;
  height: 0;
  border: 2px solid;
  border-image: linear-gradient(0deg, rgba(238, 175, 84, 0.00), rgba(255, 200, 119, 0.99) 49%, rgba(255, 200, 119, 0.00)) 2 2;
}

.canChangeFigure {
  height: 40px;
  font-size: 24px;
  font-family: PangMenZhengDao-3, PangMenZhengDao-3-Regular;
  font-weight: normal;
  text-align: left;
  color: #ebebeb;

}

.airspaceTitle {
  background-image: url("../../assets/img/2dmap/kong_yu_guan_li.png");
  background-repeat: no-repeat;
  height: 50px;
  text-align: left;
  padding-left: 27px;
  background-size: 80% 38px;
  width: 100%;

}
.airspaceTitle span{
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 400;
  text-align: left;
  font-family: PangMenZhengDao, PangMenZhengDao-3;
  text-shadow: -2px 0px 3.68px 0.16px rgba(16, 1, 0, 0.50);
  color: #ffffff;
}

.situationMapBtns {
  position: absolute;
  top: 80px;
  right: 12px;
  z-index: 1000;
  display: flex;
}

.levelOneBtns{
  position: absolute;
  bottom: 0;
  right: 12px;
  z-index: 1003;
  cursor: pointer;
  width: 48px;
}
.levelOneBtns .chooseBtn {
  width: 100%;
  height: 48px;
  text-align: center;
  position: relative;
  align-items: center;
  display: flex;
  margin-bottom: 10px;
}
.levelOneBtns .backHome .img{
  width: 48px;
  height: 48px;
  background-image: url("../../assets/img/2dmap/home_page.png");
  /* background-size: 100% 100%; */
  z-index: 1000;
}
.levelOneBtns .backHome:hover .img {
  width: 48px;
  height: 48px;
  background-image: url("../../assets/img/2dmap/home_page_click.png");
  z-index: 1000;

}

.situationMapBtns .situationBtn {
  width: 50px;
  height: 45px;
  margin-left: 10px;
  padding: 0 10px 0 5px;
  border: none;
  cursor: pointer;
  /* background-image: url("../../assets/img/2dmap/iconbac2.png"); */
  background-size: 100% 100%;
}

.situationMapBtns .situationBtn img {
  vertical-align: middle;
  margin-right: 2px;
}

.situationMapBtns .situationBtn span {
  vertical-align: middle;
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #dff2ff;
  line-height: 45px;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85);
}

.situationMapBtns .active span {
  color: #fee075 !important;
  text-shadow: 2px 3px 6px rgba(21, 48, 88, 0.85) !important;
}

.openAir span {
  display: none;
  position: absolute;
  bottom: 5px;
  left: -75px;
  width: 55px;
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px;
  font-size: 12px;
  letter-spacing: 1px;
  z-index: 100;
}

.openAir:hover span {
  display: block;
}

>>> .custom-marker {
  box-sizing: border-box;
  color: #fff;
  padding: 12px 5px 5px 5px;
  text-align: center;
  font-weight: bold;
  position: relative;
  width: 135px; /* 控制宽度 */
  background-image: url("../../../static/xian_fei.png");
}

.inputSuffix >>> .el-input__suffix-inner {
  width: 60px;
  cursor: pointer;
  z-index: 1004;
  user-select: none;
}

.inputSuffix >>> .el-input--suffix {
  padding-right: 50px;
}

.coordinate >>> .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
  border: none;
  background-color: transparent
}

.coordinateRow {
  display: flex;
  flex-wrap: wrap;
}

.coordinate {
  width: 48%;
}

.coordinate:nth-of-type(odd) {
  margin-right: 4%;
}

.preViewBtn {

}

.announcement-container {
  z-index: 1003;
  position: absolute;
  left: 425px;
  top: 80px;
  width: calc(100% - 850px);
  height: 80px;
  overflow: hidden; /* 隐藏超出部分 */
  background: rgba(23, 11, 1, 0.50);
  margin: 20px auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.announcement-list {
  position: absolute;
  width: 100%; /* 列表宽度 */
  transition: transform 0.5s ease; /* 平滑过渡 */
}

.announcement-item {
  color: #f1f1f1;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 5px 10px;
  height: 80px;
}

.icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  background: url('../../assets/img/2dmap/gong_gao.png') no-repeat;
  background-size: 100%;
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%); /* 向上滚动 */
  }
}

.leaflet-tooltip.anim-tooltip {
  background: red !important;
}

>>> .el-checkbox__label {
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #ffffff;
  line-height: 40px;
}

>>> .el-form-item__label {
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #ffffff;
  line-height: 40px;
}

>>> .el-input__inner {
  background: rgba(1,9,17,0.68) !important;
}

>>> .el-textarea__inner {
  color: #FFFFFF;
  background: rgba(1,9,17,0.68) !important;
}

>>> .el-input__suffix-inner .el-button {
  color: #FFFFFF !important;
}

>>> .positionSet {
  position: relative;
  z-index: 9999;
}

.leaflet-tooltip.anim-tooltip {
  background: red !important;
}

>>> #chooseAirspace .el-checkbox__label {
  color: #FFFFFF;
}

/* 右侧 */
.changeAirSpace {
  position: absolute;
  /* top: 91px; */
  bottom: 100px;
  right: 8px;
  width: 50px;
  z-index: 1001;
  cursor: pointer;
  background: transparent;
}

.changeAirSpaceBottom {
  position: absolute;
  /* top: 91px; */
  top: 10px;
  right: 0;
  width: 50px;
  z-index: 1000;
  cursor: pointer;
  background: transparent;

}


#chooseAirspace .close {
  cursor: pointer;
  position: absolute;
  //right: -30px;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 26px;
  background: rgba(15, 86, 115, 0.4);
}
.timeSlider{
  color: #FFFFFF;
  margin: 10px 120px;
  position: fixed;
  top:145px;
  width: 732px;
}
.timeListWrap{
  margin-top: 75px;
  height: calc(100% - 70px);
  overflow: auto;
}
>>>.timeSlider .el-slider__bar {
  background-color: #00aeff;
  border-color: #00aeff;
}
>>>.timeSlider .el-slider__button  {
  border-color: #00aeff;
}
.heightSliderWrap{
  position: absolute;
  top: 220px;
  background: rgba(1,9,17,0.68);
  height: calc(100% - 235px);
  width: 90px;
display: flex;
flex-direction: column;
  align-items: center;
  justify-content: start;
  z-index: 1000;
  margin-left: 5px;
}
 .spanClass{
  z-index: 1050;
   color: #00aeff;
  height: 50px;
  line-height: 50px;
}
 >>> .el-select{
   width: 100%;
 }
.heightSlider{
  width: 80px;
  display: block;
  //position: absolute;
  //top: 250px;
  /* height: calc(100% - 270px); */
  height: 90%;
  //width: 50px;
}
>>> .heightSlider .el-slider__marks-text {
  color: white;
  width: 50px;
  text-align: left;
}
>>>.heightSlider .el-slider__bar{
  background-color: #00aeff;
  border-color: #00aeff;
}
>>>.heightSlider .el-slider__button{
  border-color: #00aeff;
}

</style>



// WEBPACK FOOTER //
// src/components/home/AreaspaceSynergy.vue